import React, { useState } from 'react';
import { Card } from '../../components/ui/Card';
import { Button } from '../../components/ui/Button';
import { TabNavigation } from '../../components/operations/TabNavigation';
import { Plus, UserPlus, Repeat, Star, Crown, AlertTriangle, Moon, Gift, Trash2, Edit2, X } from 'lucide-react';
const CUSTOMER_TABS = [{
  label: 'Overview',
  path: ''
}, {
  label: 'Database',
  path: 'database'
}, {
  label: 'Segments',
  path: 'segments'
}, {
  label: 'Reviews',
  path: 'reviews'
}, {
  label: 'Insights',
  path: 'insights'
}];
const AUTO_SEGMENTS = [{
  name: 'New',
  icon: <UserPlus size={24} className="text-blue-500" data-id="element-1148" />,
  rule: 'First order in last 30 days',
  count: 312,
  metrics: {
    avgOrder: '1,890 RSD',
    freq: 'First order',
    revenue: '589K RSD'
  },
  color: 'blue'
}, {
  name: 'Returning',
  icon: <Repeat size={24} className="text-teal-500" data-id="element-1149" />,
  rule: '2-4 orders total',
  count: 892,
  metrics: {
    avgOrder: '2,150 RSD',
    freq: '12 days',
    revenue: '1.9M RSD'
  },
  color: 'teal'
}, {
  name: 'Regular',
  icon: <Star size={24} className="text-yellow-500" data-id="element-1150" />,
  rule: '5-10 orders total',
  count: 489,
  metrics: {
    avgOrder: '2,350 RSD',
    freq: '8 days',
    revenue: '1.1M RSD'
  },
  color: 'yellow'
}, {
  name: 'VIP',
  icon: <Crown size={24} className="text-accent-primary" data-id="element-1151" />,
  rule: '11+ orders total',
  count: 221,
  metrics: {
    avgOrder: '2,520 RSD',
    freq: '5 days',
    revenue: '8.2M RSD'
  },
  highlight: '🏆 Top 8% generate 40% of revenue',
  color: 'purple'
}, {
  name: 'At Risk',
  icon: <AlertTriangle size={24} className="text-accent-warning" data-id="element-1152" />,
  rule: 'Regular/VIP, no order 30+ days',
  count: 23,
  metrics: {
    avgOrder: '2,400 RSD',
    freq: 'Was 7 days',
    revenue: 'Potential Loss'
  },
  color: 'orange'
}];
const CUSTOM_SEGMENTS = [{
  name: 'Burger Lovers',
  icon: '🍔',
  rule: 'Ordered burgers 5+ times',
  count: 342
}, {
  name: 'Night Owls',
  icon: '🌙',
  rule: '>50% orders after 21:00',
  count: 128
}, {
  name: 'Loyalty Members',
  icon: '🎁',
  rule: 'WhatsApp program members',
  count: 456
}];
export function Segments() {
  const [showCreateModal, setShowCreateModal] = useState(false);
  return <div className="space-y-6 animate-in fade-in duration-500" data-id="element-1153">
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4" data-id="element-1154">
        <h1 className="text-2xl font-bold text-text-primary" data-id="element-1155">
          Customer Segments
        </h1>
        <Button icon={<Plus size={16} data-id="element-1157" />} onClick={() => setShowCreateModal(true)} data-id="element-1156">
          Create Segment
        </Button>
      </div>

      <TabNavigation tabs={CUSTOMER_TABS} basePath="/customers" data-id="element-1158" />

      <h3 className="font-bold text-text-secondary uppercase tracking-wider text-sm" data-id="element-1159">
        Automatic Segments
      </h3>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-1160">
        {AUTO_SEGMENTS.map((segment, i) => <Card key={i} className="flex flex-col h-full relative overflow-hidden" data-id="element-1161">
            {segment.highlight && <div className="absolute top-0 left-0 right-0 bg-accent-primary/20 text-accent-primary text-xs font-bold py-1 px-4 text-center" data-id="element-1162">
                {segment.highlight}
              </div>}
            <div className={`p-6 flex-1 ${segment.highlight ? 'pt-10' : ''}`} data-id="element-1163">
              <div className="flex justify-between items-start mb-4" data-id="element-1164">
                <div className="flex items-center gap-3" data-id="element-1165">
                  <div className={`w-12 h-12 rounded-xl flex items-center justify-center bg-${segment.color}-500/10`} data-id="element-1166">
                    {segment.icon}
                  </div>
                  <div data-id="element-1167">
                    <h3 className="font-bold text-lg" data-id="element-1168">{segment.name}</h3>
                    <div className="text-xs text-text-secondary" data-id="element-1169">
                      {segment.rule}
                    </div>
                  </div>
                </div>
                <div className="text-right" data-id="element-1170">
                  <div className="font-bold text-2xl" data-id="element-1171">{segment.count}</div>
                  <div className="text-xs text-text-secondary" data-id="element-1172">customers</div>
                </div>
              </div>

              <div className="grid grid-cols-3 gap-2 text-center text-sm py-4 border-t border-white/5" data-id="element-1173">
                <div data-id="element-1174">
                  <div className="text-text-secondary text-xs" data-id="element-1175">Avg Order</div>
                  <div className="font-bold" data-id="element-1176">{segment.metrics.avgOrder}</div>
                </div>
                <div data-id="element-1177">
                  <div className="text-text-secondary text-xs" data-id="element-1178">Frequency</div>
                  <div className="font-bold" data-id="element-1179">{segment.metrics.freq}</div>
                </div>
                <div data-id="element-1180">
                  <div className="text-text-secondary text-xs" data-id="element-1181">Revenue</div>
                  <div className="font-bold" data-id="element-1182">{segment.metrics.revenue}</div>
                </div>
              </div>

              <div className="flex gap-2 mt-4" data-id="element-1183">
                <Button className="flex-1" variant="secondary" size="sm" data-id="element-1184">
                  View
                </Button>
                <Button className="flex-1" variant="secondary" size="sm" data-id="element-1185">
                  Export
                </Button>
              </div>
            </div>
          </Card>)}
      </div>

      <h3 className="font-bold text-text-secondary uppercase tracking-wider text-sm pt-4" data-id="element-1186">
        Custom Segments
      </h3>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-1187">
        {CUSTOM_SEGMENTS.map((segment, i) => <Card key={i} className="p-4 flex flex-col justify-between" data-id="element-1188">
            <div data-id="element-1189">
              <div className="flex justify-between items-start mb-2" data-id="element-1190">
                <div className="flex items-center gap-2 font-bold text-lg" data-id="element-1191">
                  <span data-id="element-1192">{segment.icon}</span> {segment.name}
                </div>
                <div className="text-sm font-bold bg-white/10 px-2 py-1 rounded" data-id="element-1193">
                  {segment.count}
                </div>
              </div>
              <p className="text-sm text-text-secondary mb-4" data-id="element-1194">{segment.rule}</p>
            </div>
            <div className="flex gap-2 border-t border-white/5 pt-3" data-id="element-1195">
              <Button size="sm" variant="secondary" className="flex-1" data-id="element-1196">
                View
              </Button>
              <button className="p-2 hover:bg-white/10 rounded text-text-secondary" data-id="element-1197">
                <Edit2 size={16} data-id="element-1198" />
              </button>
              <button className="p-2 hover:bg-white/10 rounded text-accent-error" data-id="element-1199">
                <Trash2 size={16} data-id="element-1200" />
              </button>
            </div>
          </Card>)}
        <button onClick={() => setShowCreateModal(true)} className="border-2 border-dashed border-white/10 rounded-xl p-6 flex flex-col items-center justify-center text-text-secondary hover:border-accent-primary hover:text-accent-primary transition-colors min-h-[150px]" data-id="element-1201">
          <Plus size={32} className="mb-2" data-id="element-1202" />
          <span className="font-bold" data-id="element-1203">Create New Segment</span>
        </button>
      </div>

      {/* Create Segment Modal */}
      {showCreateModal && <div className="fixed inset-0 bg-black/80 flex items-center justify-center z-50 p-4" data-id="element-1204">
          <Card className="w-full max-w-lg" data-id="element-1205">
            <div className="flex justify-between items-center mb-6" data-id="element-1206">
              <h3 className="text-xl font-bold" data-id="element-1207">Create Segment</h3>
              <button onClick={() => setShowCreateModal(false)} className="text-text-secondary hover:text-white" data-id="element-1208">
                <X size={20} data-id="element-1209" />
              </button>
            </div>

            <div className="space-y-4 mb-6" data-id="element-1210">
              <div data-id="element-1211">
                <label className="block text-xs font-bold text-text-secondary uppercase mb-1" data-id="element-1212">
                  Segment Name
                </label>
                <div className="flex gap-2" data-id="element-1213">
                  <input type="text" className="flex-1 bg-background border border-white/10 rounded-lg px-3 py-2 text-sm focus:outline-none focus:border-accent-primary" placeholder="e.g. High Spenders" data-id="element-1214" />
                  <button className="px-3 py-2 bg-white/5 rounded-lg border border-white/10 text-xl" data-id="element-1215">
                    💰
                  </button>
                </div>
              </div>

              <div data-id="element-1216">
                <div className="flex justify-between items-center mb-2" data-id="element-1217">
                  <label className="block text-xs font-bold text-text-secondary uppercase" data-id="element-1218">
                    Conditions
                  </label>
                  <button className="text-xs text-accent-primary hover:underline" data-id="element-1219">
                    + Add Rule
                  </button>
                </div>

                <div className="bg-background-elevated p-3 rounded-lg border border-white/10 space-y-3" data-id="element-1220">
                  <div className="flex items-center gap-2" data-id="element-1221">
                    <select className="bg-background border border-white/10 rounded px-2 py-1 text-sm focus:outline-none" data-id="element-1222">
                      <option data-id="element-1223">Total Spent</option>
                      <option data-id="element-1224">Order Count</option>
                    </select>
                    <select className="bg-background border border-white/10 rounded px-2 py-1 text-sm focus:outline-none" data-id="element-1225">
                      <option data-id="element-1226">is greater than</option>
                      <option data-id="element-1227">is less than</option>
                    </select>
                    <input type="text" className="w-24 bg-background border border-white/10 rounded px-2 py-1 text-sm focus:outline-none" placeholder="50000" data-id="element-1228" />
                    <button className="text-text-secondary hover:text-accent-error" data-id="element-1229">
                      <X size={14} data-id="element-1230" />
                    </button>
                  </div>

                  <div className="flex items-center gap-2 text-xs font-bold text-text-secondary justify-center" data-id="element-1231">
                    AND
                  </div>

                  <div className="flex items-center gap-2" data-id="element-1232">
                    <select className="bg-background border border-white/10 rounded px-2 py-1 text-sm focus:outline-none" data-id="element-1233">
                      <option data-id="element-1234">Order Count</option>
                      <option data-id="element-1235">Total Spent</option>
                    </select>
                    <select className="bg-background border border-white/10 rounded px-2 py-1 text-sm focus:outline-none" data-id="element-1236">
                      <option data-id="element-1237">is at least</option>
                    </select>
                    <input type="text" className="w-24 bg-background border border-white/10 rounded px-2 py-1 text-sm focus:outline-none" placeholder="5" data-id="element-1238" />
                    <button className="text-text-secondary hover:text-accent-error" data-id="element-1239">
                      <X size={14} data-id="element-1240" />
                    </button>
                  </div>
                </div>
              </div>

              <div className="bg-accent-primary/10 p-3 rounded-lg text-sm flex justify-between items-center" data-id="element-1241">
                <span className="text-accent-primary font-medium" data-id="element-1242">Preview</span>
                <span className="font-bold" data-id="element-1243">87 customers match</span>
              </div>
            </div>

            <div className="flex justify-end gap-3" data-id="element-1244">
              <Button variant="secondary" onClick={() => setShowCreateModal(false)} data-id="element-1245">
                Cancel
              </Button>
              <Button onClick={() => setShowCreateModal(false)} data-id="element-1246">
                Create Segment
              </Button>
            </div>
          </Card>
        </div>}
    </div>;
}